import axios from "../config/axios";
import Constants from "../data/Constants";

export const getCurriculumList = async (pagination = {}) => {
  return await axios.get(Constants.ENDPOINTS.CURRICULUM.ALL).then((res) => {
    return res.data.result;
  });
};

export const getCurriculumNameList = async (pagination = {}) => {
  return await axios.get(Constants.ENDPOINTS.CURRICULUM.ALL).then((res) => {
    return res.data.result;
  });
};

export const getSingleCurriculum = async (id, pagination = {}) => {
  return await axios
    .get(Constants.ENDPOINTS.CURRICULUM.SINGLE + id)
    .then((res) => {
      return res.data.result;
    });
};

export const updateSingleCurriculum = async (id, data) => {
  return await axios
    .put(Constants.ENDPOINTS.CURRICULUM.UPDATE + id, data)
    .then((res) => {
      return res.data.result;
    });
};

export const createSingleCurriculum = async (data) => {
  return await axios
    .post(Constants.ENDPOINTS.CURRICULUM.CREATE, data)
    .then((res) => {
      return res.data.result;
    });
};
